import { Box, useTheme } from '@mui/material'
import { Autoclave, AutoclaveType, Frequency } from '../types'
import autoclaveImage from '../../../../images/items/autoclave.jpg'
import CompliancePlip from '../../../../components/CompliancePlip'
import { getAutoclaveTypeName, getAutoclaveFrequency } from '../utils/helpers'
import { AutoclaveTypeId } from '../enums'

type AutoclaveHeader = {
  autoclave: Autoclave,
  autoclaveTypeById: Map<AutoclaveTypeId, AutoclaveType>,
  autoclaveFrequencyById: Map<number, Frequency>,
}

const AutoclaveHeader = (props: AutoclaveHeader) => {
  const { autoclave, autoclaveTypeById, autoclaveFrequencyById } = props

  const theme = useTheme()

  const autoclaveTypeName = getAutoclaveTypeName(autoclave, autoclaveTypeById)
  const frequency = getAutoclaveFrequency(autoclave, autoclaveFrequencyById)

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ mr: 4 }}>
        <img style={{ width: '100px' }} src={autoclaveImage} alt="autoclave image" />
      </Box>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CompliancePlip medium message={autoclave.autoclave_compliance.compliance.message_short} status={autoclave.autoclave_compliance.compliance.compliance_status} />{' '}
          <span style={{ color: theme.palette.color50555b.main }} className="m-l-8">
            {autoclave.autoclave_name}
          </span>
        </Box>
        <Box sx={{ display: 'flex', fontSize: '13px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', fontWeight: 'bold', color: theme.palette.color50555b.main, mr: 2 }}>
            <Box>Serial/Sterilizer #:</Box>
            <Box>Type:</Box>
            <Box>Brand:</Box>
            <Box>Model:</Box>
            <Box>Frequency:</Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', color: theme.palette.color50555b.main }}>
            <Box>{autoclave.autoclave_serial}</Box>
            <Box>{autoclaveTypeName || 'Unknown'}</Box>
            <Box>{autoclave.autoclave_brand ?? <span style={{ color: theme.palette.danger.main }}>[Not Entered]</span>}</Box>
            <Box>{autoclave.autoclave_model ?? <span style={{ color: theme.palette.danger.main }}>[Not Entered]</span>}</Box>
            <Box>{frequency || 'Unknown'}</Box>
          </Box>
        </Box>
      </Box>
    </Box>    
  )
}

export default AutoclaveHeader
